import { render, staticRenderFns } from "./Messages.vue?vue&type=template&id=3a07200e&scoped=true&"
import script from "./Messages.vue?vue&type=script&lang=js&"
export * from "./Messages.vue?vue&type=script&lang=js&"
import style0 from "./Messages.vue?vue&type=style&index=0&id=3a07200e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a07200e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a07200e')) {
      api.createRecord('3a07200e', component.options)
    } else {
      api.reload('3a07200e', component.options)
    }
    module.hot.accept("./Messages.vue?vue&type=template&id=3a07200e&scoped=true&", function () {
      api.rerender('3a07200e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/reservationAdministration/Messages.vue"
export default component.exports